module.exports = __webpack_public_path__ + "static/media/TN-Men-Outer-Rakuten.8ff022c7.svg";